<template>
  <div class="scarfnewsagencyIndex">
		<div class="contentTop">
			<banner></banner>
			
			<div class="contentMiddle">
				<headerview></headerview>
				
				<div class="con_all">		
					<div class="con_one">
						<div class="black_one_top">
							<tipsign :titleName="'红领巾小记者风采'"></tipsign>
							<span style="color: #E61F26;font-size: 0.14rem;cursor: pointer;" @click="moreRedScarf">更多> </span>
						</div>
						
						<div class="con_car">
							<div class="con_car_son" v-for="(item,index) in redscarflist" :key="index" @click="todetailhl(item)">
								<div class="img_car"><img :src="$fileAccessHttpUrl(item.avatar_dictText)" alt=""/></div>
								<div class="title_car">{{item.type_dictText}}</div>
								<div class="text_car">{{item.name}} {{item.gender_dictText}} {{item.post}}</div>
							</div>
						</div>
						
					</div>
					
					<div class="con_two">
						<div class="con_two_a">
							<notice :titleName="'校园情报站'" :sign="3"></notice>
						</div>
						<div class="con_two_b">
							<notice :titleName="'社会情报站'" :sign="4"></notice>
						</div>
						<div class="con_two_c">
							<div class="black_one_top">
								<tipsign :titleName="'小小主人翁'"></tipsign>
								<span style="color: #E61F26;font-size: 0.14rem;cursor: pointer;" @click="toMaster">更多> </span>
							</div>
							
							<div class="blacktwo">
								<div class="con_two_c_car" v-for="(item,index) in littlemasterlist" :key="index">
									<!-- <img src="../../../static/index/topback@2x.png" alt=""/> -->
									<div class="">
										<div class="a">{{item.userId}}</div>
										<div class="b">{{item.opinion}}</div>
										<div class="c">{{item.createTime}}</div>
									</div>
								</div>
								
								<div class="addsuggestions">
									<div class="addbtn" @click="toaddbtn">
										添加建议
									</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
				
			</div>	
						
		<footview></footview>

  </div>
  
 </div> 
</template>

<script>
import headerview from "../../../components/headerview/headerview.vue";
import tipsign from "../../../components/tipsign/tipsign.vue";
import notice from "../../../components/notice/notice.vue";

export default {
  components: {
		headerview,
		tipsign,
		notice,
  },
  
  data() {
		return {
			redscarflist:[],
			littlemasterlist:[],
			
		};
  },
  
  mounted() {
	   this.getRedScarf()
	   this.getlittleMaster()
	   this.$onScrollT()
  },
  
  methods: {
	  //
	  toaddbtn(){
			this.$router.push({ path: '/feedback' });
	  },
	  
	  //红领巾小记者风采
	  getRedScarf(){
			this.$get(`web/youngpioneers/ypYoungPioneers/list?pageSize=4&pageNo=1`).then(res=>{
				  if(res.success){
						this.redscarflist = res.result.records
				  }
			})
	  },
	  
	  //小小主人翁
	  getlittleMaster(){
			this.$get(`web/opinionsuggest/list?pageSize=3&pageNo=1`).then(res=>{
				  if(res.success){
						this.littlemasterlist = res.result.records
				  }
			})
	  },
	  
	  moreRedScarf(){
			this.$router.push({ path: '/pressrelease', query: {type:8} });
	  },
	  
	  toMaster(){
		   this.$router.push({ path: '/masterIndex', query: {}});
	  },
	  
	  //跳转到红领巾小记者风采详情
	  todetailhl(item){
		  this.$router.push({ path: '/pressrelease/detail', query: {id:item.id,type:8} });
	  },
	  
  }
};
</script>

<style scoped lang="scss">
	.scarfnewsagencyIndex{
		.contentTop{
			// background-image: linear-gradient(#FFFFFF, #E98257);
		}
		
		.contentMiddle{
			padding-top: 1.7rem;
			height: 11.2rem;
			// border: 1px solid #FFFFFF;
			// background: linear-gradient(0deg, #FFFFFF, #E98257);
			
			.con_all{
				height: 10rem;	
				margin: 0rem auto;
				// margin-left: 4rem;
				// margin-right: 4rem;
				width: 12.15rem;
				background: #FFFFFF;
				.con_one{
					height: 3rem;
					margin-top: 0.1rem;
					padding: 0.1rem;
					background: #FFFFFF;
					// border: 1px solid red;
					.black_one_top{
						display: flex;
						align-items: center;
						height: 0.4rem;
						justify-content: space-between;
						border-bottom: 0.01rem solid #ededed;
						
					}
					.con_car{
						display: flex;
						align-items: center;
						.con_car_son{
							margin-top: 0.4rem;
							cursor: pointer;
							height:1.8rem;
							width: 3rem;
							// border: 1px solid red;
							font-size: 0.16rem;
							display: flex;
							justify-content: center;
							flex-direction: column;
							width: 24%;	
							margin-left: 0.1rem;				
							.img_car{
								cursor: pointer;
								display: flex;
								align-items: center;
								justify-content: center;			
							}
							img{
								// height:1.2rem;
								// width: 3rem;
								border: 1px solid #ededed;
								height:1.48rem;
								width: 1.04rem;
							}							
							.title_car{
								margin-top: 0.1rem;
								font-weight: bold;
								text-align: center;
							}
							.text_car{
								color: #999999;
								text-align: center;
							}
						}
					}
					
				}					
				.con_two{
					height: 6rem;
					// border: 1px solid red;
					display: flex;
					padding: 0.1rem;
					.con_two_a{
						flex: 1;
					}
					.con_two_b{
						flex: 1;
						// border: 1px solid red;
					}
					.con_two_c{
						flex: 1;
						.black_one_top{
							display: flex;
							align-items: center;
							height: 0.55rem;
							justify-content: space-between;
							border-bottom: 0.01rem solid #ededed;
						}
						.blacktwo{
							height: 3rem;
						}
						.con_two_c_car{
							display: flex;
							align-items: center;
							height: 1.4rem;
							font-size: 0.16rem;
							margin-right: 0.2rem;
							img{
								height: 1.14rem;
								width:1.14rem;
								margin-right: 0.1rem;
							}
							.a{
								font-weight: bold;
								height: 0.4rem;
								line-height: 0.4rem;
							}
							.b{
								color: #999999;
							}
							.c{
								color: #666666;
								height: 0.4rem;
								line-height: 0.4rem;
							}
						}
						.addsuggestions{
							height:0.8rem;
							// border: 1px solid red;
							display: flex;
							align-items: center;
							cursor: pointer;
							.addbtn{
								width: 0.89rem;
								height: 0.26rem;
								line-height: 0.26rem;
								text-align: center;
								background: #E70012;
								font-size: 0.14rem;
								font-weight: 400;
								color: #FFFFFF;
							}
						}
						
						
					}
				}
				
			}
			
		}	
		
		
	}
	
</style>
